<div class="d-flex flex-row justify-content-start mb-2">
  <button class="btn btn-info mr-3" [style.min-width.px]="102" (click)="inviteUser()">+ Invite user</button>
</div>

<div *ngIf="users$ | async as users">
  <div class="scroll-table">
    <table class="table tr-table tr-striped">
      <thead>
      <tr>
        <th>User</th>
        <th>Role</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let user of users | slice: start : end">
        <td>
        <span class="d-flex flex-column align-items-start">
          <span class="font-weight-bold" [innerText]="user.name"></span>
          <span [innerText]="user.email"></span>
        </span>
        </td>
        <td [innerText]="user.role | titlecase"></td>
        <td>
        <span class="d-flex flex-row">
          <button class="edit btn btn-icon btn-info mr-2" (click)="editUser(user)">
            <tr-icon [icon]="icon.edit" [color]="color.white"></tr-icon>
          </button>

          <button class="remove btn btn-danger" (click)="removeFromLocation(user)"
          >Remove from location</button>
        </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex flex-row justify-content-end" *ngIf="users.length > 0">
    <div class="pagination">
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="maxSize"
        [ellipses]="true"
        [collectionSize]="users.length"
      ></ngb-pagination>
    </div>
  </div>
</div>
